const nameProp = Symbol("FakeStore.name");

export function fakeStoreImplementation<T>(
    name: string,
    mockImplementation: Partial<T> = {},
): T {
    return new Proxy(
        { [nameProp]: name },
        {
            get(target, prop) {
                if (!(prop in mockImplementation)) {
                    const message = `${target[nameProp]}.${String(
                        prop,
                    )} is not implemented!`;
                    throw new Error(message);
                }

                const mockProperty = (mockImplementation as any)[prop];

                return typeof mockProperty === "function"
                    ? (...args: any[]) =>
                          mockProperty.apply(mockImplementation, args)
                    : mockProperty;
            },
        },
    ) as unknown as T;
}
